import TextEditInlineBlock from './TextEditInlineBlock'

export default TextEditInlineBlock
